<div class="flex flex-col justify-start">
  <mnc-member-search
    lazyComponent
    [tenantId]="tenantId"
    [tenantName]="tenantName"
    [lineOfBusinessId]="lineOfBusinessId"
    (rowClicked)="handleRowClicked($event)"
    (errorOccurred)="
      notificationService.showError(
        $event?.detail?.title,
        $event?.detail?.message
      )
    "
  />

  <div class="flex flex-row gap-2 justify-end my-2">
    <button
      aria-label="Cancel"
      class="p-button-secondary"
      pButton
      type="button"
      (click)="cancelClick()"
    >
      Cancel
    </button>
    <button
      pButton
      type="button"
      (click)="submitClick()"
      [disabled]="!selectedMember"
    >
      Assign Member
    </button>
  </div>
</div>
